export default function getTemplateSettingValue(setting, mergedConfig) {
  if (setting && setting.useTemplate && setting.template) {
    const templateValue = mergedConfig['Templates/' + setting.template].value;
    return templateValue;
  } else {
    return setting;
  }
}
